module.exports = __webpack_public_path__ + "img/slider2.80edf1c0.svg";